import { empApi } from "./client";

// Lịch sử giao dịch / phản hồi (tab "Phản hồi") -> { items, pagination }
// params: { page, limit, bookingId | lockingId | ttkqId | salesContractId }
export const getTransactionHistoryApi = (params) =>
  empApi.get("/transactionHistory/app", params);

// Chuyển giao dịch (booking / locking / ttkq / hdmb) đều dùng chung endpoint này.
// body: { newEmployeeId, type, bookingId|lockingId|ttkqId|salesContractId }
export const createTransferRequestApi = (body) =>
  empApi.post("/transferRequests/app", body);

// Tìm nhân viên kinh doanh nhận chuyển (department = 1) -> { items }
export const searchSalesEmployeeApi = (params) =>
  empApi.get("/employee/search", { department: 1, ...params });
